import React from 'react';

const InformasiSKP = React.lazy(() => import('./InformasiSKP'))
const Penilaian360 = React.lazy(() => import('./Penilaian360'))
const LaporanSKP = React.lazy(() => import('./LaporanSKP'))
const FormulirSKP = React.lazy(() => import('./LaporanSKP/LaporanSKP2017/TableLaporanAwalTahun/FormulirSKP'))
const FormulirSKPBulanan = React.lazy(() => import('./LaporanSKP/LaporanSKP2017/TableLaporanAwalTahun/FormulirSKPBulanan'))
const SasaranKinerjaPegawai = React.lazy(() => import('./SasaranKinerjaPegawai'))
const DataSKPPegawai = React.lazy(() => import('./SasaranKinerjaPegawai/DataSKPPegawai'))
const DaftarKegiatanSKPPegawai = React.lazy(() => import('./SasaranKinerjaPegawai/DaftarKegiatanSKPPegawai'))

export const skpConfigs = [
    {
        path: '/skp/informasi-skp',
        element: <InformasiSKP />,
    },
    {
        path: '/skp/informasi-skp/pengantar-aplikasi',
        element: <InformasiSKP />,
    },
    {
        path: '/skp/informasi-skp/capaian-skp',
        element: <InformasiSKP />,
    },
    {
        path: '/skp/informasi-skp/kualitas-output',
        element: <InformasiSKP />,
    },
    {
        path: '/skp/informasi-skp/tugas-tambahan',
        element: <InformasiSKP />,
    },
    {
        path: '/skp/informasi-skp/kreativitas',
        element: <InformasiSKP />,
    },
    {
        path: '/skp/informasi-skp/perilaku-kinerja',
        element: <InformasiSKP />,
    },
    {
        path: '/skp/informasi-skp/kata-operasional',
        element: <InformasiSKP />,
    },
    {
        path: '/skp/penilaian-360',
        element: <Penilaian360 />,
    },
    {
        path: '/skp/laporan-skp',
        element: <LaporanSKP />,
    },
    {
        path: '/skp/laporan-skp/laporan-skp-2017',
        element: <LaporanSKP />,
    },
    {
        path: '/skp/laporan-skp/laporan-skp-perilaku-360',
        element: <LaporanSKP />,
    },
    {
        path: '/skp/laporan-skp/laporan-skp-berbasis-bsc',
        element: <LaporanSKP />,
    },
    {
        path: '/skp/sasaran-kinerja-pegawai',
        element: <SasaranKinerjaPegawai />,
    },  
    {
        path: '/skp/sasaran-kinerja-pegawai/data-skp/:id',
        element: <DataSKPPegawai />,
    },
    {
        path: '/skp/sasaran-kinerja-pegawai/data-skp/daftar-kegiatan/:id',
        element: <DaftarKegiatanSKPPegawai />,
    },
    {
        path: '/skp/laporan-skp/laporan-skp-2017/formmulir-skp/:id',
        element: <FormulirSKP />,
    },
    {
        path: '/skp/laporan-skp/laporan-skp-2017/formulir-skp-bulanan/:id',
        element: <FormulirSKPBulanan />,
    },
]